import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getInquiry = async (chatId: string): Promise<AxiosResponse> =>
  AxiosInstance.get('livechat/inquiries.getOne', {
    params: {
      roomId: chatId,
    },
  });
